import React from 'react';
import { useTranslation } from 'react-i18next';
import { Routes, Route, Navigate } from 'react-router-dom';
import SalariesAlertsPage from './SalariesAlertsPage';
import SalariesPage from './SalariesPage';
import SalariesConfigPage from './SalariesConfigPage';
import PrimesIndemnitesPage from './PrimesIndemnitesPage';
import AvancesPretPage from './AvancesPretPage';
import IncidentsPrejudicesPage from './IncidentsPrejudicesPage';
import MissionsDeplacementsPage from './MissionsDeplacementsPage';
import HeuresSupplementairesPage from './HeuresSupplementairesPage';
import DeclarationsSocialesPage from './DeclarationsSocialesPage';
import JournalCaissePage from './JournalCaissePage';
import ParametresPage from './ParametresPage';
import VirementsBancairesPage from './VirementsBancairesPage';
import RetenuesDiversesPage from './RetenuesDiversesPage';
import SalairesAnalysesRapportsPage from './SalairesAnalysesRapportsPage';
import PayrollDashboardPage from './PayrollDashboardPage';

const SalariesMainPage = () => {
  const { t } = useTranslation();
  const p = (key, opts) => t(`modules.salaires.pages.salariesMainPage.${key}`, opts);

  return (
    <div aria-label={p('title')}>
    <span className="sr-only">{p('subtitle')}</span>
    <Routes>
      <Route path="/" element={<Navigate to="/salaries/dashboard" replace />} />
      <Route path="/dashboard" element={<PayrollDashboardPage />} />
      <Route path="/alertes" element={<SalariesAlertsPage />} />
      
      {/* Calcul Détaillé - SalariesPage shows CalculSalaires by default */}
      <Route path="/stats" element={<SalariesPage defaultView="stats" />} />
      <Route path="/stats/*" element={<SalariesPage defaultView="stats" />} />
      
      {/* Journal de Caisse */}
      <Route path="/journal" element={<JournalCaissePage />} />
      
      {/* Paramètres de Calcul */}
      <Route path="/parametres" element={<ParametresPage />} />
      
      {/* Primes & Indemnités */}
      <Route path="/bonuses" element={<PrimesIndemnitesPage />} />
      
      {/* Avances & Prêts */}
      <Route path="/advances" element={<AvancesPretPage />} />
      
      {/* Incidents & Dommages */}
      <Route path="/incidents" element={<IncidentsPrejudicesPage />} />
      
      {/* Missions & Déplacements */}
      <Route path="/missions" element={<MissionsDeplacementsPage />} />
      
      {/* Heures Supplémentaires */}
      <Route path="/overtime" element={<HeuresSupplementairesPage />} />
      
      {/* GOSI / SANED / WPS Declarations */}
      <Route path="/gosi" element={<DeclarationsSocialesPage />} />
      <Route path="/cnas" element={<Navigate to="/salaries/gosi" replace />} />
      
      {/* Virements Bancaires */}
      <Route path="/virements-bancaires" element={<VirementsBancairesPage />} />
      
      {/* Retenues Diverses */}
      <Route path="/retenues-diverses" element={<RetenuesDiversesPage />} />
      
      {/* Configuration */}
      <Route path="/config" element={<SalariesConfigPage />} />

      {/* Analyses & Rapports */}
      <Route path="/analyses-rapports" element={<SalairesAnalysesRapportsPage />} />
      
      {/* Legacy route redirects */}
      <Route path="/calculation" element={<Navigate to="/salaries/stats" replace />} />
      
      {/* Catch-all - redirect to dashboard */}
      <Route path="/*" element={<Navigate to="/salaries/dashboard" replace />} />
    </Routes>
    </div>
  );
};

export default SalariesMainPage;

